<div>
  <div class="header">
      <h2 class="new-business-heading">Add More Info</h2>
      <mat-icon mat-dialog-close>close</mat-icon>
  </div>

  <app-alert *ngIf="(showErrorMessage$ | async)"
    [message]="errMessage ? errMessage : 'Failed to create new lead'"
    level="error"
    (dismissed)="newLeadErrorMessageDismissed.emit()">
  </app-alert>

  <form [formGroup]="addBusinessForm">
      <formly-form [options]='formOptions' [form]="addBusinessForm" [fields]="fields" [model]="model" ></formly-form>
      <span><strong>* = Required fields</strong></span>
      <mat-dialog-actions align="end">
          <button mat-button matStepperPrevious>Back</button>
          <button mat-raised-button [color]="'primary'" data-cy="submitNewLead"
            [disabled]="(!addBusinessForm.valid || (loading$ | async))" mat-raised-button type="submit" (click)="submit()">
            <span *ngIf="!(loading$ | async) && !(duplicateLead$ | async)">Add Business</span>
            <span *ngIf="!(loading$ | async) && (duplicateLead$ | async)">Update Business</span>
            <mat-spinner
              diameter="24"
              class="tw-inline-block"
              *ngIf="(loading$ | async)">
            </mat-spinner>
          </button>
        </mat-dialog-actions>
  </form>
</div>
